export default __webpack_public_path__ + "static/media/SconeMixProductInfo1.39965de8.jpg";